import { EventEmitter, Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpEvent, HttpEventType, HttpHeaders } from '@angular/common/http';
import { catchError, map, timeout } from 'rxjs/operators';
import { environment } from "src/environments/environment";
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { NotifierService } from 'angular-notifier';
import { MatDialog } from '@angular/material/dialog';
import { LoginPopupComponent } from 'src/app/shared/login-popup/login-popup.component';
import { LoginService } from '../login.service';
import { RollbarService } from 'src/app/shared/services/rollbar/rollbar.service';

const DEFAULT_OPTIONS = {
  httpOptions: {
        headers: new HttpHeaders().set('Content-Type', 'application/json'),
        withCredentials: true,
        params:{}
      }
}

export class ApiOptions {
  method:'GET'|'POST'|'PUT'|'DELETE';
  relativeUrl:string;
  body:any;
  options:any;
}

@Injectable({
  providedIn: "root",
})

export class ApiRequestService {
  // declaring the base URL
  private baseUrl: string = environment.apiUrl;
  private loginPopupDialogRef;
  
  constructor(
    private http: HttpClient,
    private router: Router,
    private notifier: NotifierService,
    private loginSevice: LoginService,
    private dialog: MatDialog,
    private rollbarService: RollbarService
  ) { 
    loginSevice.onPopopLoginEvent.subscribe(() => {
      this.onPopupLoggedIn();
    })
  }

  public request(method: ApiOptions['method'],relativeUrl:ApiOptions['relativeUrl'],body?:any,option?:any) {
    let options:any = {};
    options['method'] = method; 
    options['relativeUrl'] = relativeUrl; 
    options['body'] = body ? body : {}; 
    options['options'] = option ? option : {}; 
    //This Function will Always return an Observale with api response(Result or error) and call actual http request function
    return new Observable((subscriber) => {
      this.httpCall(options, (response) => {
        subscriber.next(response);
        subscriber.complete();
      });
    });
  }

  // public requestFileUpload(method: ApiOptions['method'], relativeUrl: ApiOptions['relativeUrl'], body?: any, option?: any) {
  //   let options: any = {} // Test;
  //   options['method'] = method;
  //   options['relativeUrl'] = relativeUrl;
  //   options['body'] = body ? body : {};
  //   options['options'] = option ? option : {}; 
  
  //   // Return an Observable
  //   return new Observable((subscriber) => {
  //     this.httpCallForFileUpload(options, (response) => {
  //       if (response.progress !== undefined) {
  //         // Handle progress updates (you can emit progress here to a component)
  //         console.log('Upload Progress In Api :', response.progress);
  //         this.emitFileUploadPogress.emit({progress: response.progress })
  //       } else if (response.response) {
  //         // Handle final response
  //         console.log('final response In Api :', response.response);
  //         subscriber.next(response.response);
  //       }
  //       subscriber.complete();
  //     });
  //   });
  // }

  private httpCall(options:ApiOptions, cb) {
    //This function will execute actual api request 
    let method = options.method.toLowerCase();
    this.http[method](...this.apiRequestData(options))
    .pipe(
      // timeout(options.options.timeout | 30000)
    )
    .subscribe(
      (response: any) => {
        cb(response);
      },
      (error: any) => {
        if (![401, 403].includes(error?.status)) {
          this.rollbarService.error(`API Request Error: ${options.method} ${options.relativeUrl}`, { error });
        } else {
          console.warn(`Suppressed Rollbar log for ${error.status}: ${error.message}`);
        }
          this.handleError(error, cb);
        }
      );
  }
  

  public httpCallForFileUpload(options:ApiOptions, cb) {
    //This function will execute actual api request 
    let method = options.method.toLowerCase();
    this.http[method](...this.apiRequestData(options))
    .pipe(
      // timeout(options.options.timeout | 30000)
      map((event: HttpEvent<any>) => {
        switch (event.type) {
          case HttpEventType.UploadProgress:
            if (event.total) {
              const progress = Math.round(100 * event.loaded / event.total); // Calculate progress percentage
              cb({ progress });
            }
            break;
          case HttpEventType.Response:
            cb({ response: event.body });
            break;
        }
      }),
      catchError((error: any) => {
        if (![401, 403].includes(error?.status)) {
          this.rollbarService.error(`API Request Error: ${options.method} ${options.relativeUrl}`, { error });
        } else {
          console.warn(`Suppressed Rollbar log for ${error.status}: ${error.message}`);
        }
        this.handleError(error, cb);
        throw error; // Rethrow the error to propagate it
      })
    )
    .subscribe();

  }
  private handleError(error, cb) {
    if (error.status === 401) {
      this.router.navigate(["home/access-denied"]);
    } else if (error.status === 403) {
      // this.notifier.notify("error", "User is not authorised");
      // localStorage.clear();
      // this.router.navigate(["login"]);
      this.openPopupLogin();
    }
    cb(error);
  }

  private openPopupLogin() {
    localStorage.setItem('redirectUrl', this.router.url);
    if(!this.loginSevice.isPopupLoginOpened) {
    this.loginSevice.isPopupLoginOpened = true;
      this.loginPopupDialogRef = this.dialog.open(LoginPopupComponent, {
          width: '300px',
          height: "320px",
          panelClass: 'popup-login-container',
          backdropClass: 'popup-login-backdrop',
          position: {
              top:'8%',
              left:'40%'
          },
          data: {},
          disableClose: true
        })
    }
  }

  onPopupLoggedIn() {
    if(this.loginPopupDialogRef) this.loginPopupDialogRef.close();
    this.loginSevice.isPopupLoginOpened = false;
  }

  private apiRequestData(options:ApiOptions) {
    //This function will set all params within http call
    //If method is not post or put, it will not send body object to the api
    let arr = [];

    //Below function will return absolute url to be requested for api
    //If baseUrl are not sent in options object this function will take default baseUrl
    let url = this.getURL(options.options, options.relativeUrl);
    arr.push(url);

    if(options.method == 'POST' || options.method == 'PUT') {
      arr.push(options.body);
    }

    // Reinitialize DEFAULT_OPTIONS.httpOptions to make sure it's not containing old request headers.
    DEFAULT_OPTIONS.httpOptions = {
      headers: new HttpHeaders().set('Content-Type', 'application/json'),
      withCredentials: true,
      params:{}
    }

    //Below function will set http options with headers data
    //If httpOptions are sent in options object, the below function will set to that else it will execute default httpoptions
    let httpOption = this.getHeaders(options.options);
    arr.push(httpOption);

    return arr;
  }

  private getHeaders(options) {
    let httpOptions = options.httpOptions ? options.httpOptions : DEFAULT_OPTIONS.httpOptions;
    if(options.query) {
      httpOptions.params = options.query;
    }
    return httpOptions;
  }

  private getURL(options: any, relativeUrl: ApiOptions['relativeUrl']) {
    if (options.baseUrl) {
      return options.baseUrl+relativeUrl;
    }
    return this.baseUrl+relativeUrl;
  }

}